import { render, staticRenderFns } from "./PromotionDetailApp.vue?vue&type=template&id=340de0c2&scoped=true"
import script from "./PromotionDetailApp.vue?vue&type=script&lang=js"
export * from "./PromotionDetailApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "340de0c2",
  null
  
)

export default component.exports